import { observable } from "mobx";
import { Type } from "class-transformer";
import OutgoingSenderBankAccountResponse from "./outgoingSenderBankAccountResponse";
import OutgoingTransferCounterpartyBankAccountResponse from "./outgoingTransferCounterpartyBankAccountResponse";
import OutgoingTransferPaymentStatus from "./outgoingTransferPaymentStatus";
import TransferPaymentType from "./transferPaymentType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingBankTransactionDetailResponse {
  @observable
  variableSymbol?: number;

  @observable
  specificSymbol?: number;

  @observable
  constantSymbol?: number;

  @observable
  @Type(() => Date)
  postingDate?: Date;

  @observable
  @Type(() => Date)
  exportedDate?: Date;

  @observable
  paymentType?: TransferPaymentType;

  @observable
  messageForRecipient?: string;

  @observable
  @Type(() => OutgoingTransferCounterpartyBankAccountResponse)
  recipientBankAccount?: OutgoingTransferCounterpartyBankAccountResponse;

  @observable
  @Type(() => OutgoingSenderBankAccountResponse)
  senderBankAccount?: OutgoingSenderBankAccountResponse;

  @observable
  paidAmount!: number;

  @observable
  status!: OutgoingTransferPaymentStatus;
}
